import T from '@wojtekmaj/react-t';

import InputField from '@rewardopl/react-ui/input_field';
import RadioGroup from '@rewardopl/react-ui/radio_group';

import { Bold, Sub } from './marketing_and_age_controls.styles';

import MarketingControls from './marketing_controls';

type MarketingAndAgeControlsProps = {
  form?: string;
  is16OrOlder: boolean | null;
  marketingEmailAccepted: boolean;
  marketingProfilingAccepted: boolean;
  marketingSmsAccepted: boolean;
  setIs16OrOlder: React.Dispatch<React.SetStateAction<boolean | null>>;
  setMarketingEmailAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  setMarketingProfilingAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  setMarketingSmsAccepted: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function MarketingAndAgeControls({
  form,
  is16OrOlder,
  marketingEmailAccepted,
  marketingSmsAccepted,
  marketingProfilingAccepted,
  setIs16OrOlder,
  setMarketingEmailAccepted,
  setMarketingSmsAccepted,
  setMarketingProfilingAccepted,
}: MarketingAndAgeControlsProps) {
  return (
    <>
      <RadioGroup
        label="Declaration of age"
        name="is_16_or_older"
        onChange={(value) => {
          setIs16OrOlder(value === 'true');
        }}
        options={[
          {
            label: 'I declare that I am at least 16 years old',
            value: 'true',
          },
          {
            label: "I declare that I am not yet 16 years old, but I have my guardian's consent",
            value: 'false',
          },
        ]}
      />
      {is16OrOlder !== null ? (
        <>
          <Bold>
            <T>Marketing consents</T>
          </Bold>
          <Sub>
            <T>I declare that I consent to:</T>
          </Sub>
          <MarketingControls
            form={form}
            marketingEmailAccepted={marketingEmailAccepted}
            marketingProfilingAccepted={marketingProfilingAccepted}
            marketingSmsAccepted={marketingSmsAccepted}
            setMarketingEmailAccepted={setMarketingEmailAccepted}
            setMarketingProfilingAccepted={setMarketingProfilingAccepted}
            setMarketingSmsAccepted={setMarketingSmsAccepted}
          />
        </>
      ) : null}
      {is16OrOlder === false ? (
        <>
          <Bold>
            <T>
              If you are unsure whether you can select the consents above on your own but want to
              receive marketing communication, please provide your parent or legal guardian's email
              address
            </T>
          </Bold>
          <InputField
            label="Legal guardian’s email"
            maxLength={320}
            name="legal_guardian_email"
            placeholder="email@example.com"
            required={false}
            type="email"
          />
        </>
      ) : null}
    </>
  );
}
